import React from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "@telluscompany/design-system";
import { router } from "@router/index";
import { ErrorBoundary } from "@shared/components";
import { useResolvedToasterTheme } from "@shared/hooks";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LegalDocumentsGuard } from "@shared/components";
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@shared/config";

const workerUrl =
  "https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js";

const App: React.FC = () => {
  const toasterTheme = useResolvedToasterTheme();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Worker workerUrl={workerUrl}>
          <RouterProvider router={router} />
        </Worker>
        <Toaster theme={toasterTheme} />
        <LegalDocumentsGuard />
        {import.meta.env.VITE_REACT_QUERY_DEVTOOLS_ENABLED && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
